// @ts-nocheck
import * as Types from '../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type ReloadCostsBannerQueryVariables = Types.Exact<{
  filter: Types.CostConfigurationSummariesFilter;
}>;


export type ReloadCostsBannerQuery = { __typename?: 'Query', costConfigurationSummaries: { __typename?: 'CostConfigurationSummariesPage', entities: Array<{ __typename?: 'CostConfigurationSummary', id: string }> } };

export type ReloadCostsBannerOptionsQueryVariables = Types.Exact<{
  filter: Types.CostOptionGroupSummariesFilter;
}>;


export type ReloadCostsBannerOptionsQuery = { __typename?: 'Query', costOptionGroupSummaries: Array<{ __typename?: 'CostOptionGroupRollup', offerings: Array<{ __typename?: 'CostOptionGroupOffering', summary?: { __typename?: 'CostOptionGroupSummary', id: string } | null | undefined }> }> };


export const ReloadCostsBannerDocument = gql`
    query ReloadCostsBanner($filter: CostConfigurationSummariesFilter!) {
  costConfigurationSummaries(filter: $filter) {
    entities {
      id
    }
  }
}
    `;

/**
 * __useReloadCostsBannerQuery__
 *
 * To run a query within a React component, call `useReloadCostsBannerQuery` and pass it any options that fit your needs.
 * When your component renders, `useReloadCostsBannerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReloadCostsBannerQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useReloadCostsBannerQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ReloadCostsBannerQuery, ReloadCostsBannerQueryVariables> & ({ variables: ReloadCostsBannerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ReloadCostsBannerQuery, ReloadCostsBannerQueryVariables>(ReloadCostsBannerDocument, options);
      }
export function useReloadCostsBannerLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ReloadCostsBannerQuery, ReloadCostsBannerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ReloadCostsBannerQuery, ReloadCostsBannerQueryVariables>(ReloadCostsBannerDocument, options);
        }
// @ts-ignore
export function useReloadCostsBannerSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ReloadCostsBannerQuery, ReloadCostsBannerQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ReloadCostsBannerQuery, ReloadCostsBannerQueryVariables>;
export function useReloadCostsBannerSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ReloadCostsBannerQuery, ReloadCostsBannerQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ReloadCostsBannerQuery | undefined, ReloadCostsBannerQueryVariables>;
export function useReloadCostsBannerSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ReloadCostsBannerQuery, ReloadCostsBannerQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ReloadCostsBannerQuery, ReloadCostsBannerQueryVariables>(ReloadCostsBannerDocument, options);
        }
export type ReloadCostsBannerQueryHookResult = ReturnType<typeof useReloadCostsBannerQuery>;
export type ReloadCostsBannerLazyQueryHookResult = ReturnType<typeof useReloadCostsBannerLazyQuery>;
export type ReloadCostsBannerSuspenseQueryHookResult = ReturnType<typeof useReloadCostsBannerSuspenseQuery>;
export type ReloadCostsBannerQueryResult = ApolloReactCommon.QueryResult<ReloadCostsBannerQuery, ReloadCostsBannerQueryVariables>;
export const ReloadCostsBannerOptionsDocument = gql`
    query ReloadCostsBannerOptions($filter: CostOptionGroupSummariesFilter!) {
  costOptionGroupSummaries(filter: $filter) {
    offerings {
      summary {
        id
      }
    }
  }
}
    `;

/**
 * __useReloadCostsBannerOptionsQuery__
 *
 * To run a query within a React component, call `useReloadCostsBannerOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReloadCostsBannerOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReloadCostsBannerOptionsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useReloadCostsBannerOptionsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ReloadCostsBannerOptionsQuery, ReloadCostsBannerOptionsQueryVariables> & ({ variables: ReloadCostsBannerOptionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ReloadCostsBannerOptionsQuery, ReloadCostsBannerOptionsQueryVariables>(ReloadCostsBannerOptionsDocument, options);
      }
export function useReloadCostsBannerOptionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ReloadCostsBannerOptionsQuery, ReloadCostsBannerOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ReloadCostsBannerOptionsQuery, ReloadCostsBannerOptionsQueryVariables>(ReloadCostsBannerOptionsDocument, options);
        }
// @ts-ignore
export function useReloadCostsBannerOptionsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ReloadCostsBannerOptionsQuery, ReloadCostsBannerOptionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ReloadCostsBannerOptionsQuery, ReloadCostsBannerOptionsQueryVariables>;
export function useReloadCostsBannerOptionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ReloadCostsBannerOptionsQuery, ReloadCostsBannerOptionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ReloadCostsBannerOptionsQuery | undefined, ReloadCostsBannerOptionsQueryVariables>;
export function useReloadCostsBannerOptionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ReloadCostsBannerOptionsQuery, ReloadCostsBannerOptionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ReloadCostsBannerOptionsQuery, ReloadCostsBannerOptionsQueryVariables>(ReloadCostsBannerOptionsDocument, options);
        }
export type ReloadCostsBannerOptionsQueryHookResult = ReturnType<typeof useReloadCostsBannerOptionsQuery>;
export type ReloadCostsBannerOptionsLazyQueryHookResult = ReturnType<typeof useReloadCostsBannerOptionsLazyQuery>;
export type ReloadCostsBannerOptionsSuspenseQueryHookResult = ReturnType<typeof useReloadCostsBannerOptionsSuspenseQuery>;
export type ReloadCostsBannerOptionsQueryResult = ApolloReactCommon.QueryResult<ReloadCostsBannerOptionsQuery, ReloadCostsBannerOptionsQueryVariables>;